export default "__VITE_ASSET__2c026b51__"